import { createRoute,Outlet } from '@tanstack/react-router'

import { profileRoute } from '..'

export const affiliateRoute = createRoute({
  getParentRoute: () => profileRoute,
  path: 'affiliate',
  component: Outlet,
})
